import { MeetingServiceOrder } from "../../modules/merchant/accounting/accounting/accountingTypes"
import { Organizer, OrganizerType } from "../types/OrganizerTypes"

type OderPersonType = {
    person?: Organizer
    creator?: Organizer
    responsible?: Organizer
    organizer?: Organizer
}

export const getOrderPerson = (organizers?: Organizer[]): OderPersonType => {
    if (!organizers || organizers.length === 0) {
        return { person: undefined, creator: undefined, responsible: undefined, organizer: undefined }
    }

    const creator = organizers.find(
        (org) => org.type === OrganizerType.CREATOR || org.organizerType === OrganizerType.CREATOR,
    )
    const responsible = organizers.find(
        (org) => org.type === OrganizerType.RESPONSIBLE || org.organizerType === OrganizerType.RESPONSIBLE,
    )
    const organizer = organizers.find(
        (org) => org.type === OrganizerType.ORGANIZER || org.organizerType === OrganizerType.ORGANIZER,
    )

    // Meeting host priority: RESPONSIBLE > ORGANIZER > CREATOR
    return { person: responsible || organizer || creator, creator, responsible, organizer }
}

export function getOrganizerPhones(organizer?: Organizer): ReadonlyArray<string> {
    const phones = [organizer?.phone || organizer?.businessPhone, organizer?.mobilePhone]
    return phones.filter((phone, index): phone is string => Boolean(phone) && phones.indexOf(phone) === index)
}

export function getOrganizers(meetingOrder: MeetingServiceOrder) {
    return meetingOrder.organizers ?? meetingOrder.meetingDetails?.organizers
}
